import {getWindow} from "../window"
import {TP_PAGE_IDENTIFIER} from "../../config/constants"

export const doCountryRedirect = (): boolean => {
    const w = getWindow()
    const entryPoints = [
        w?.document.querySelector(`${TP_PAGE_IDENTIFIER}`),
        w?.platmodflags && w.platmodflags.countryRedirect,
    ]
    if (w && entryPoints.some(entryPoint => entryPoint)) return true
    return false
}

export const doCookiePolicy = (): boolean => {
    const w = getWindow()
    const entryPoints = [
        w?.document.querySelector(`${TP_PAGE_IDENTIFIER}`),
        w?.platmodflags && w.platmodflags.modernisedCookieConsent,
    ]
    if (w && entryPoints.some(entryPoint => entryPoint)) return true
    return false
}

export const doGoogleAnalytics = (): boolean => {
    const w = getWindow()
    const entryPoints = [
        w?.document.querySelector(`${TP_PAGE_IDENTIFIER}`),
        w?.platmodflags && w.platmodflags.googleAnalytics,
    ]
    if (w && entryPoints.some(entryPoint => entryPoint)) return true
    return false
}

export const doGTMDataLayerEvents = (): boolean => {
    const w = getWindow()
    const entryPoints = [
        w?.document.querySelector(`${TP_PAGE_IDENTIFIER}`),
        w?.platmodflags && w.platmodflags.gtmDataLayerEvents,
    ]
    if (w && entryPoints.some(entryPoint => entryPoint)) return true
    return false
}

export const doMonetateEvents = (): boolean => {
    const w = getWindow()
    const entryPoints = [
        w?.document.querySelector(`${TP_PAGE_IDENTIFIER}`),
        w?.platmodflags && w.platmodflags.monetateEvents,
    ]
    if (w && entryPoints.some(entryPoint => entryPoint)) return true
    return false
}

export const doSearchABAdaptor = (): boolean => {
    const w = getWindow()
    const entryPoints = [
        w?.document.querySelector(`${TP_PAGE_IDENTIFIER}`),
        w?.platmodflags && w.platmodflags.searchABAdaptor,
    ]
    if (w && entryPoints.some(entryPoint => entryPoint)) return true
    return false
}

export const doUserVariables = (): boolean => {
    const w = getWindow()
    const entryPoints = [
        w?.document.querySelector(`${TP_PAGE_IDENTIFIER}`),
        w?.platmodflags && w.platmodflags.userVariables,
    ]
    if (w && entryPoints.some(entryPoint => entryPoint)) return true
    return false
}
